import React from 'react';
import { Button } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Login = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="login-screen">
      <div className="login-panel">
        <div className="text-center mb-4">
          <img
            src="/logo192.png"
            alt=""
            className="login-brand-logo"
            width="72"
            height="72"
          />
          <h1 className="login-brand">Budgie</h1>
          <p className="text-muted mb-0 mt-2">Shared expenses, salary-aware splits.</p>
        </div>

        {error === 'unauthorized' && (
          <div className="alert alert-danger" role="alert">
            Access denied. Only authorized email addresses can use this application.
          </div>
        )}

        <div className="d-grid gap-2">
          <Button variant="primary" size="lg" onClick={login} className="py-3">
            Sign in with Google
          </Button>
        </div>

        <p className="mt-4 mb-0 text-center text-muted small">
          Private household app — invited accounts only.
        </p>
      </div>
    </div>
  );
};

export default Login;
